import React, { Fragment } from "react";
import Head from "next/head";

import { Tours } from "../../components/TakeTheTourModal/TakeTheTourModal";
import siteMetaData from "../../config/siteMetaData";

import Header from "../../components/Navigation/Header/Header";
import TopNavigation from "../../components/Navigation/TopNavigation/TopNavigation";
import Footer from "../../components/Footer/Footer";
import ToastWrapper from "../../components/Toast/ToastWrapper/ToastWrapper";
import CookieBanner from "../../components/common/CookieBanner/CookieBanner";

import styles from "./AppLayout.module.css";
import WelcomeIntroductionModal from "../../components/WelcomeIntroductionModal/WelcomeIntroductionModal";

interface Props {
    children: React.ReactNode;
    appendTitle?: string;
    tour?: keyof typeof Tours;
}

const AppLayout = ({ children, appendTitle, tour }: Props) => (
    <Fragment>
        <Head>
            <title>{siteMetaData.title + (appendTitle ? ` | ${appendTitle}` : "")}</title>
            <meta name="description" content={siteMetaData.description} />
        </Head>
        <WelcomeIntroductionModal />
        <CookieBanner />
        <Header notification />
        <TopNavigation tour={tour} />
        <main className={styles.AppLayout}>{children}</main>
        <Footer />
        <ToastWrapper />
    </Fragment>
);

export default AppLayout;
